import "./style.scss";
import * as React from "react";
import { Form, Icon, Popover } from "antd";
import { Select } from "../../../form";
const FormItem = Form.Item;
// https://stackoverflow.com/questions/46155/validate-email-address-in-javascript
const EMAIL_REGEX =
  /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

class EmailSelect extends React.Component<any, EmailSelectProps> {
  labelClassName() {
    let name = !this.props.disabled ? "required" : "";
    return name;
  }

  emailValidator(rule: any, emails: string[], callback: any) {
    if (emails) {
      emails.forEach((email: string) => {
        if (!email.match(EMAIL_REGEX))
          callback("Please enter only valid emails");
      });
    }
    callback();
  }

  renderHelperHover() {
    if (this.props.popover) {
      let classname = "email-select-hover-helper";
      return (
        <div className={classname}>
          &nbsp;&nbsp;&nbsp;
          <Popover
            placement="topLeft"
            content={this.props.popover}
            title="Help"
            trigger="hover"
          >
            <Icon type="question-circle" />
          </Popover>
        </div>
      );
    }
  }

  render() {
    const {
      name,
      disabled,
      form,
      form_value_key,
      value,
      tokenSeparators,
      handleChange,
      placeholder,
      label
    } = this.props;

    return (
      <div className="email-select">
        <div className="email-select-label">
          <label className={this.labelClassName()}>{`${label} :`}</label>
          {this.renderHelperHover()}
        </div>
        <FormItem hasFeedback={!disabled}>
          {form.getFieldDecorator(form_value_key, {
            rules: [
              {
                validator: this.emailValidator
              },
              {
                required: !disabled,
                message: "Please enter at least one valid email address"
              }
            ],
            initialValue: value
          })(
            <Select
              className="form-length"
              name={name}
              mode="tags"
              placeholder={placeholder}
              handleChange={handleChange}
              tokenSeparators={tokenSeparators}
              form={form}
              form_value_key={form_value_key}
              disabled={disabled}
            />
          )}
        </FormItem>
      </div>
    );
  }
}

interface EmailSelectProps extends IGenericFieldProps {
  value: string[] | string;
  handleChange: (e: any) => void;
  disabled: boolean;
  name: string;
  popover?: any;
  tokenSeparators?: string[];
  placeholder?: string;
  form?: any;
  form_value_key?: string;
}

export default EmailSelect;



// WEBPACK FOOTER //
// ./client/modules/common/components/EmailSelect/index.tsx